import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { DockType } from '@classes/dock-type';
import { DockTypeService } from 'app/core/services/dock-type.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-dock-type-list',
  templateUrl: './dock-type-list.component.html',
  styleUrls: ['./dock-type-list.component.scss']
})
export class DockTypeListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredDockTypes();
    }
  }
  @Input() placeHolder: string;

  myControl!: FormControl;

  dockTypes: DockType[] = [];
  filteredDockTypes: Observable<DockType[]> | undefined;

  constructor(
    public dockTypeService: DockTypeService
  ) {
    this._initList();
  }

  ngOnInit() {
  }

  private _initList() {
    this.dockTypeService.getDockTypes().subscribe(dockTypes => {
      this.dockTypes = dockTypes
      .sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));;
      this._initFilteredDockTypes();
    }, error => {
      console.error(error);
    })
  }

  private _initFilteredDockTypes(): void {
    if (this.myControl) {
      this.filteredDockTypes = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return [];
          })
        );
    }
  }

  private _filter(value: string): DockType[] {
    const filterValue = value.toLowerCase();
    return this.dockTypes.filter(option => (option.name || '').toLowerCase().includes(filterValue));
  }

  displayFn(dockType?: DockType): string {
    return dockType ? (dockType.name || '') : '';
  }
}
